import { render } from "./uploadDocument.vue?vue&type=template&id=233a5831&scoped=true"
import script from "./uploadDocument.vue?vue&type=script&lang=js"
export * from "./uploadDocument.vue?vue&type=script&lang=js"

import "./uploadDocument.vue?vue&type=style&index=0&id=233a5831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233a5831"]])

export default __exports__